// src/components/SubscriptionSelectModal.tsx

import React from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { Subscription } from '../types';

interface SubscriptionSelectModalProps {
  show: boolean;
  onHide: () => void;
  subscriptions: Subscription[];
  handleSubscriptionUpdate: (subscriptionId: number) => void;
  handleShowCreateSubscriptionModal: () => void;
}

const SubscriptionSelectModal: React.FC<SubscriptionSelectModalProps> = ({
  show,
  onHide,
  subscriptions,
  handleSubscriptionUpdate,
  handleShowCreateSubscriptionModal
}) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Select or Create Plesk Subscription</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="subscriptionSelection">
          <Form.Label>Subscription</Form.Label>
          <Form.Control as="select" onChange={(e) => handleSubscriptionUpdate(Number(e.target.value))}>
            <option key="0" value="0">
              Choose a subscription
            </option>
            {subscriptions.map((subscription) =>
              subscription.id !== null ? (
                <option key={subscription.id} value={subscription.id}>
                  {subscription.domainName}
                </option>
              ) : null
            )}
          </Form.Control>
        </Form.Group>
        <Button variant="success" onClick={handleShowCreateSubscriptionModal}>
          Create New Subscription
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default SubscriptionSelectModal;
